<script>

import axios from 'axios';
const propostaURL = process.env.VUE_APP_API_URL+"propostas";

export default class PropostasRepository{
    
    async getPropostas(token,page){
        
        const baseURL = page
        const headers = {
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
        const response = await axios.get(baseURL,{headers:headers});
        return response;

    }

    async createPropostaDoc(id, token) {
        const baseURL = `${propostaURL}/gerar-documento/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        try {
            const response = await axios.get(baseURL,{headers:headers});
            return response;
        } catch (error) {
            console.error("Erro ao gerar proposta:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async  getProposta(page,token,id) {
        
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.get(baseURL,{ headers });
        return response;
       
    }

    async  deleteProposta(token,id) {
        
        const baseURL = `proposta/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.delete(baseURL,{ headers });
        return response;
       
    }

    async importPropostaFiles(data,token,page){

        const baseURL = page;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const formData = data
        const response = await axios.post(baseURL, formData, { headers: headers });
        return response;

    }


}
</script>
